import "normalize.css";
import "./index.scss";

import Header from "./components/Header";
import DarkModeButton from "./components/DarkModeButton";
import About from "./components/About";
import SkillsSection from "./components/Skills";
import { ThemeProvider } from "./contexts/theme";
import { useDarkMode } from "./useDarkMode";

function App() {
const [theme, toggleTheme, componentMounted] = useDarkMode();

  if (!componentMounted) {
    return <div />;
  }

  return (
    <ThemeProvider value={theme}>
      <div className={`App ${theme}`}>
        <Header />
        <About theme={theme} />
        <SkillsSection theme={theme} />
        <DarkModeButton theme={theme} toggleTheme={toggleTheme} />
      </div>
    </ThemeProvider>
  );
}

export default App;
